import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "@/App";
import { Reveal, TituloSeccion } from "./Reveal";

export default function Testimonios() {
  const { t } = useLang();
  const items = t.home.testimonios.items;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const tmr = setInterval(() => setIdx((v) => (v + 1) % items.length), 7000);
    return () => clearInterval(tmr);
  }, [items.length]);

  return (
    <section className="bg-cactus/95 py-20 md:py-28" data-testid="seccion-testimonios">
      <div className="mx-auto max-w-3xl px-6 text-center md:px-10">
        <TituloSeccion pre={t.home.testimonios.pre} titulo={t.home.testimonios.titulo} claro />
        <Reveal delay={0.1}>
          <div className="relative min-h-[190px] md:min-h-[160px]" data-testid="testimonios-carrusel">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={idx}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -16 }}
                transition={{ duration: 0.55 }}
                data-testid={`testimonio-${idx}`}
              >
                <p className="font-serif text-xl leading-relaxed text-sand md:text-2xl">{items[idx].texto}</p>
                <footer className="mt-6 text-[11px] font-bold tracking-[0.26em] text-sand/70">{items[idx].autor}</footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>
          <div className="mt-8 flex items-center justify-center gap-4">
            <button
              onClick={() => setIdx((v) => (v - 1 + items.length) % items.length)}
              className="border border-sand/40 p-2 text-sand transition-colors hover:bg-sand hover:text-ink"
              data-testid="testimonios-prev-btn"
              aria-label="Anterior"
            >
              <ChevronLeft size={18} strokeWidth={1.6} />
            </button>
            <div className="flex gap-1.5">
              {items.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  aria-label={`Testimonio ${i + 1}`}
                  className={`h-1.5 transition-all ${i === idx ? "w-6 bg-sand" : "w-2 bg-sand/40"}`}
                  data-testid={`testimonios-dot-${i}`}
                />
              ))}
            </div>
            <button
              onClick={() => setIdx((v) => (v + 1) % items.length)}
              className="border border-sand/40 p-2 text-sand transition-colors hover:bg-sand hover:text-ink"
              data-testid="testimonios-next-btn"
              aria-label="Siguiente"
            >
              <ChevronRight size={18} strokeWidth={1.6} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}